import { Table } from "@radix-ui/themes";

interface TableBlockProps {
  headers: string[];
  rows: string[][];
  highlightRules?: Record<string, string>;
}

export function TableBlock({ headers, rows, highlightRules }: TableBlockProps) {
  // why: canvas blocks come from parsed AI JSON and are never runtime-validated,
  // so a declared `string` cell can be a number and `.toLowerCase()` would throw
  // during render. `row.map` below has the same problem for a non-array row.
  const getCellClass = (cell: unknown): string => {
    if (!highlightRules) return "";
    const text = typeof cell === "string" ? cell : String(cell ?? "");
    for (const [pattern, className] of Object.entries(highlightRules)) {
      if (text.toLowerCase().includes(pattern.toLowerCase())) {
        return className;
      }
    }
    return "";
  };

  return (
    <Table.Root variant="surface" size="1" data-testid="table-block">
      <Table.Header>
        <Table.Row>
          {(headers ?? []).map((header, idx) => (
            <Table.ColumnHeaderCell key={idx}>{header}</Table.ColumnHeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {(rows ?? []).map((row, rowIdx) => (
          <Table.Row key={rowIdx}>
            {(Array.isArray(row) ? row : []).map((cell, cellIdx) => (
              <Table.Cell key={cellIdx} className={getCellClass(cell)}>
                {cell}
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
}
